import { render, staticRenderFns } from "./UIcon.vue?vue&type=template&id=07473770&scoped=true&"
import script from "./UIcon.vue?vue&type=script&lang=js&"
export * from "./UIcon.vue?vue&type=script&lang=js&"
import style0 from "./UIcon.vue?vue&type=style&index=0&id=07473770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07473770",
  null
  
)

export default component.exports